import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { LOGIN_URL, HOME_REDIRECT_URL } from '../../utils/redirect-const';
import { ROLE_ADMIN, ROLE_APP_USER, ROLE_GUEST } from '../../utils/roles';

const LimitedAccessRoute = ({ element: Component, auth, allowRole, ...rest }) => {
  const [loading, setLoading] = useState(true); // Stan do śledzenia ładowania

  useEffect(() => {
    // Symuluj sprawdzenie stanu autoryzacji
    if (auth) {
      setLoading(false); // Ustaw na false, gdy auth jest gotowy
    }
  }, [auth]);

  // Jeśli wciąż się ładowuje, zwróć null lub loader
  if (loading) {
    return null; // lub <div>Loading...</div>
  }

  // Jeśli użytkownik nie ma dostępu
  if (!allowRole.includes(auth.role)) {
    return <Navigate to={HOME_REDIRECT_URL} />
  }

  return Component; // Zwróć komponent, jeśli wszystko jest w porządku
};

LimitedAccessRoute.propTypes = {
  auth: PropTypes.object.isRequired,
  allowRole: PropTypes.arrayOf(PropTypes.oneOf([
    ROLE_GUEST,
    ROLE_ADMIN,
    ROLE_APP_USER,
  ])),
  element: PropTypes.element.isRequired,
};

LimitedAccessRoute.defaultProps = {
  allowRole: [],
};

export default LimitedAccessRoute;
